import React from 'react';
import '../style/spinner.css';

const Spinner = () => <div className="lds-hourglass spinner" />;

export default Spinner;
